import { handleOfcAccess } from '~auth/redeemOfcAccess';

// Public route: Argo opens it with a one-time ticket (PE-2215). It must stay
// outside runProtectedRoute, which would start the Auth0 login.
export const ofcAccessRoute = async () => {
  document.title = 'Accesso da Argo | Giotto';
  await handleOfcAccess();
};
